<template>
    <v-container class="report-body ma-0 pb-4">
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="12" md="6">
                        <div class="d-flex align-center">
                            <v-icon class="mr-3" color="primary">mdi-credit-card-clock</v-icon>
                            <span>Relatório de Cartões Pendentes</span>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6" class="text-right">
                        <v-btn
                            color="success"
                            class="mr-3"
                            @click="exportToCsv"
                            :disabled="!hasData"
                        >
                            <v-icon class="mr-2" small>mdi-download</v-icon>
                            Exportar CSV
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="refreshData"
                            :loading="loading"
                        >
                            <v-icon class="mr-2" small>mdi-refresh</v-icon>
                            Atualizar
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider></v-divider>

            <!-- Informações do relatório -->
            <v-card-text>
                <v-row class="mb-4">
                    <v-col cols="12">
                        <v-alert
                            type="info"
                            outlined
                            class="mb-4"
                        >
                            <div class="d-flex align-center">
                                <v-icon class="mr-2">mdi-information</v-icon>
                                <div>
                                    <strong>Sobre este relatório:</strong><br>
                                    Este relatório mostra cartões virtuais com status pendente para reservas confirmadas
                                    cujo check-out já passou da data atual. <b>Estes cartões podem necessitar de atenção manual</b>.
                                </div>
                            </div>
                        </v-alert>
                    </v-col>
                </v-row>

                <!-- Estatísticas rápidas -->
                <v-row class="mb-4" v-if="statistics">
                    <v-col cols="12" md="3">
                        <v-card outlined>
                            <v-card-text class="text-center">
                                <div class="text-h4 primary--text">{{ statistics.total }}</div>
                                <div class="text-subtitle-1">Total de Cartões</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-card outlined>
                            <v-card-text class="text-center">
                                <div class="text-h4 warning--text">{{ statistics.pending }}</div>
                                <div class="text-subtitle-1">Pendentes</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-card outlined>
                            <v-card-text class="text-center">
                                <div class="text-h4 error--text">{{ statistics.blocked }}</div>
                                <div class="text-subtitle-1">Bloqueados</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-card outlined>
                            <v-card-text class="text-center">
                                <div class="text-h4 success--text">{{ getValueInReais(statistics.totalValue) }}</div>
                                <div class="text-subtitle-1">Valor Total</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>

                <!-- Tabela do relatório -->
                <pending-cards-report-table
                    ref="pendingCardsReportTable"
                    @data-loaded="onDataLoaded"
                />
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import PendingCardsReportTable from "../../components/Reports/Tables/PendingCardsReportTable.vue";
import axios from "axios";

export default {
    name: "PendingCardsReport",

    components: {
        PendingCardsReportTable,
    },

    data: () => ({
        loading: false,
        hasData: false,
        statistics: null,
    }),

    mounted() {
        // this.loadStatistics();
        axios.get('/api/reports/pending-cards')
             .then(res => {
            console.log(res.data)
        })
    },

    methods: {
        async loadStatistics() {
            try {
                const response = await this.$http.get('/api/reports/pending-cards');
                const data = response.data;

                this.statistics = {
                    total: data.length,
                    pending: data.filter(item => item.card_status === 'pending').length,
                    blocked: data.filter(item => item.card_status === 'blocked').length,
                    totalValue: data.reduce((sum, item) => sum + parseFloat(item.total_value || 0), 0)
                };
            } catch (error) {
                console.error('Erro ao carregar estatísticas:', error);
            }
        },

        async refreshData() {
            this.loading = true;
            try {
                await this.$refs.pendingCardsReportTable.getReportData();
                await this.loadStatistics();
                this.$toast.success('Dados atualizados com sucesso!');
            } catch (error) {
                this.$toast.error('Erro ao atualizar dados');
            } finally {
                this.loading = false;
            }
        },

        exportToCsv() {
            if (this.$refs.pendingCardsReportTable) {
                this.$refs.pendingCardsReportTable.exportToCsv();
            }
        },

        onDataLoaded(hasData) {
            this.hasData = hasData;
        },

        getValueInReais(value) {
            if (!value) return 'R$ 0,00';
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        }
    }
}
</script>

<style scoped>
.report-body {
    background: #f0f0f0;
    max-width: 100%;
    min-height: 100vh;
}

.v-card-title {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
}

.text-h4 {
    font-weight: 600;
}

.text-subtitle-1 {
    color: #6c757d;
    font-weight: 500;
}
</style>
